export enum DHCPSnippetMeta {
  MODEL = "dhcpsnippet",
  PK = "id",
}
